module.exports = __webpack_public_path__ + "img/punto-verde2.2ceac6a5.png";